import { Trans } from "react-i18next";

import { Link } from "@aviary";

const SSNTooltip = () => {
  const url =
    "https://support.stripe.com/questions/date-of-birth-and-social-security-number-%28ssn%29-requirement-for-us-stripe-accounts?locale=en-x-debug";

  return (
    <Trans i18nKey="sharedOnboarding:ssnTooltipInfo">
      This is required for{" "}
      <Link isLight href={url} noExternalIcon>
        Stripe's mandatory identity verification.
      </Link>{" "}
      It is securely encrypted and used to confirm your identity and prevent financial fraud.
    </Trans>
  );
};

export { SSNTooltip };
